import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

// TODO Move to shared

@Injectable()
export class FileDownloadHelper {
    constructor() {
    }

    getFileNameFromResponseContentDisposition(response: HttpResponse<Blob>) {
        if (response && response.headers) {
            const contentDisposition = response.headers.get('content-disposition') || '';
            const filenameStarMatch = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
            if (filenameStarMatch && filenameStarMatch[1]) {
                return decodeURIComponent(filenameStarMatch[1].trim());
            }
        }
        return 'untitled';
    }

    save(blob: Blob, fileName: string) {

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    }
}
